import { ChatInterface } from "@/components/chat/chat-interface";

export default function Home() {
  return (
    <div className="flex h-screen bg-background">
      <main className="flex-1 relative overflow-hidden">
        <ChatInterface />
      </main>
    </div>
  );
}
